<template>
<div class="integralruleadd"  >
    <div class="top"> 
        <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button> 
        <el-button type="primary" size="medium"  @click="updateABCPointRules()">保存</el-button>       
    </div>
    <div class="subject" :style="`height: ${windowHeight-220}px;`">
        <div class="body">
            <el-form :model="form" ref="form" label-width="140px" class="demo-ruleForm">
                <el-form-item  label="名称" prop="sceneName" :rules="[ { required: true, message: '名称不能为空'}]">
                    <el-input type="text" :maxlength="50" placeholder="请输入名称" v-model.trim="form.sceneName" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item  label="编码"  prop="sceneCode" :rules="[ { required: true, message: '编码不能为空'}]">
                    <el-input type="text" disabled  :maxlength="10" placeholder="请输入编码" v-model.trim="form.sceneCode" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item  label="每次分值" prop="eachScore" :rules="[ { required: true, message: '每次分值不能为空'}]">
                    <el-input-number size="medium" v-model="form.eachScore" :precision="0" :step="1" :min="1" :max="100" placeholder="请输入"></el-input-number>
                </el-form-item>
                <el-form-item  label="限制方式" prop="eachScore" >
                    <el-radio v-model="form.limitType"  disabled  :label="1">无限制</el-radio>
                    <el-radio v-model="form.limitType"  disabled  :label="2">按日</el-radio>
                    <el-radio v-model="form.limitType"  disabled :label="3">限次</el-radio>
                </el-form-item>
                <el-form-item  label="每日上限" v-if="form.limitType==2" prop="limitDailyScore" :rules="[ { required: true, message: '每日上限不能为空'}]">
                    <el-input-number size="medium" v-model="form.limitDailyScore" :precision="0" :step="1" :min="1" :max="100" placeholder="请输入"></el-input-number>
                </el-form-item>
                <el-form-item  label="限次" v-if="form.limitType==3" prop="limitCount" :rules="[ { required: true, message: '限次不能为空'}]">
                    <el-input-number size="medium" v-model="form.limitCount" :precision="0" :step="1" :min="1" :max="100" placeholder="请输入"></el-input-number>
                </el-form-item>
                <el-form-item  label="备注" >
                    <el-input type="textarea" :maxlength="100" placeholder="请输入备注" v-model.trim="form.remark" autocomplete="off"></el-input>
                </el-form-item>
                
            </el-form>        
        </div>        
    </div>    
</div> 
</template>
<script>
import {updateABCPointRule,getABCPointRuleInfo} from "@/api/integralrule";
import mixin from "@/mixins/windowResize";
export default {
  data() {
    return {
        form:{
            eachScore:1,//	每次分值
            limitCount:1,//限次
            limitDailyScore:1,//每日上限制
            limitType:1,//限制方式：1无限制 2按日 3按次	integer($int32)
            remark:"",//
            sceneCode:"",//	string
            sceneName:"",//	string
            id:this.$route.query.id
        }
    };
  },
  mixins: [mixin],
  created() {
      this.getABCPointRuleInfos()
  },
  methods: {
       //详情
      getABCPointRuleInfos(){
       getABCPointRuleInfo(this.form.id).then(res => res.data).then(data => {
          if(data.code==200){
            let mydata=data.data;
            this.form.eachScore=mydata.eachScore;
            this.form.limitCount=mydata.limitCount;
            this.form.limitDailyScore=mydata.limitDailyScore;  
            this.form.limitType=mydata.limitType;  
            this.form.remark=mydata.remark; 
            this.form.sceneCode=mydata.sceneCode; 
            this.form.sceneName=mydata.sceneName; 
          }     
       })
     },
    updateABCPointRules() {
     this.$refs.form.validate((valid) => {
          if (valid) {
           this.form.limitCount=this.form.limitType==3?this.form.limitCount:"";
           this.form.limitDailyScore=this.form.limitType==2?this.form.limitDailyScore:"";
           updateABCPointRule(this.form)
        .then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: "添加成功！",
              type: "success",
              duration: 1000
            });
            this.$router.go(-1);
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(err => {});
          } 
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.integralruleadd {
  padding: 15px;
  * {
    word-break: break-all;
    word-wrap: break-word;
  }
  .top {
    border-bottom: 1px solid #e7eaec;
    padding-bottom: 10px;
  }
  .subject {
    padding-top: 10px;
    overflow: auto;
    .body {
      width: 810px;
      margin: 0 auto;
      padding-top: 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/integralrule/integralruleeidt.vue